var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", {}, [
      _c("h3", [_vm._v(_vm._s(_vm.$t("message.promo_code.my_vouchers")))])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row no-gutters" }, [
      _c("div", { staticClass: "col-lg-8 col-12" }, [
        _vm.promoCodes
          ? _c(
              "section",
              _vm._l(_vm.promoCodes, function(promoCode, index) {
                return _c("div", [
                  _c(
                    "div",
                    {
                      key: index,
                      staticClass: "card shadow-sm",
                      attrs: { role: "button" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "d-flex flex-row rounded",
                          class: [promoCode.disabled ? "-expired" : "bg-info"]
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex-fixed-width-item text-center text-white p-4 justify-content-center align-self-center"
                            },
                            [
                              _c("i", { staticClass: "fal fa-ticket fa-2x" }),
                              _vm._v(" "),
                              _c("div", { staticClass: "mt-2" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("message.promo_code.discount"))
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "bg-white py-2 px-3 flex-grow-1" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-start align-items-center"
                                },
                                [
                                  _c("div", { staticClass: "flex-fill" }, [
                                    _vm._v(
                                      _vm._s(
                                        promoCode.title
                                          ? promoCode.title
                                          : _vm.$t("message.promo_code.title", {
                                              num: promoCode.discount
                                            })
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  promoCode.disabled
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-small text-right text-secondary flex-fill"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "message.promo_code.not_available"
                                              )
                                            ) + "\n                  "
                                          )
                                        ]
                                      )
                                    : !promoCode.disabled &&
                                      _vm.getRemainingCount(promoCode)
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-small text-right text-secondary flex-fill"
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.getRemainingCount(promoCode)
                                              ) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              promoCode.province_id || promoCode.service_id
                                ? _c("div", { staticClass: "pt-2" }, [
                                    promoCode.service_id
                                      ? _c("div", {
                                          staticClass:
                                            "d-inline-block border border-info rounded text-small text-info px-2",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.$options.filters.serviceParentName(
                                                promoCode.service_id,
                                                _vm.globalState.services
                                              )
                                            )
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    promoCode.province_id
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-inline-block border border-orange rounded text-small text-orange px-2"
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm._f("multiLangName")(
                                                    _vm.globalState.cities[
                                                      promoCode.province_id
                                                    ]
                                                  )
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "pt-2" }, [
                                _c("b", { staticClass: "mb-0" }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        promoCode.discount > 0
                                          ? _vm.$t("message.promo_code.title", {
                                              num: promoCode.discount
                                            })
                                          : promoCode.description
                                      ) +
                                      "\n                  "
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              promoCode.remark
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "-status-alert text-small pt-2"
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(promoCode.remark) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("hr"),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "text-small",
                                  class: [
                                    promoCode.disabled ? "-status-offline" : ""
                                  ]
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t("message.promo_code.expiring")
                                      ) +
                                      ": " +
                                      _vm._s(
                                        _vm._f("prettyOnlyDate")(
                                          promoCode.expire_date
                                        )
                                      ) +
                                      "\n                "
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ])
              }),
              0
            )
          : _c("section", { staticClass: "text-center text-secondary p-4" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("h4", [
                _vm._v(_vm._s(_vm.$t("message.promo_code.no_promo_codes")))
              ])
            ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mb-3" }, [
      _c("i", { staticClass: "fal fa-ticket fa-3x" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6817214c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6817214c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/Voucher.vue
// module id = 1954
// module chunks = 0